export default __webpack_public_path__ + "static/media/CALogo-new.35bb0bb7.png";